import acceptLanguage from "accept-language";
import axios from "axios";
import { env } from "@/config/env.mjs";
import { LANGUAGE_DEFAULT, LANGUAGE_KEY } from "@/store/constants";

acceptLanguage.languages(["en", "pl", "ua"]);

let token = localStorage.getItem("authtoken");
let language =
  acceptLanguage.get(
    localStorage.getItem(LANGUAGE_KEY) || navigator.language.substring(0, 2)
  ) || LANGUAGE_DEFAULT;

export default axios.create({
  baseURL: env.VUE_APP_BASE_URL,
  timeout: 150000,
  useCredentials: true,
  headers: {
    Authorization: `Bearer ${token}`,
    "X-Requested-With": "XMLHttpRequest",
    "Accept-Language": language,
    "App-Name": env.VUE_APP_NAME,
  },
});
